export const idID = {
  translation: {
    common: {
      loading: 'Memuat...',
      error: 'Error',
      button: 'Kembali ke Dashboard',
      goToDashboard: 'Kembali ke Dashboard',
    },
    noPermission: {
      title: 'Tidak Ada Izin',
      description: 'Anda tidak memiliki izin untuk mengakses halaman ini.',
      goToDashboardDescription: 'Anda tidak memiliki izin untuk mengakses halaman ini. Silakan hubungi administrator untuk mendapatkan izin.',
      goToDashboardButton: 'Kembali ke Dashboard',
    },
    'Add Fulfillment': 'Tambah Fulfillment',
    'Input Your data': 'Masukkan data Anda',
    Name: 'Nama',
    Select: 'Pilih',
    search: {
      placeholder: 'Cari',
    },
    login: {
      title: 'Masuk Dengan Xinchuan Auth',
      button: 'Masuk',
      success: 'Berhasil masuk',
      authCallback_authentication_failed: 'Login authCallback authentication failed: {error}',
      authCallback_invalid_parameters: 'Login authCallback invalid parameters',
      authCallback_invalid_state_parameter: 'Login authCallback invalid state parameter',
      authCallback_failed: 'Login authCallback failed',
      authCallback_success: 'Login authCallback successful',
      authCallback_completing_authentication: 'Login authCallback completing Authentication',
      authCallback_redirecting: 'Login authCallback redirecting',
    },
    sidebar: {
      overview: 'Gambaran Umum',
      operational: 'Operasional',
      dashboard: 'Dasbor',
      fulfillment: 'Kelola Pemenuhan',
      addFulfillment: 'Tambah Pemenuhan',
      aggregator: 'Kelola Agregator',
      report: 'Pusat Laporan',
      products: 'Produk',
      wallet: 'Saldo Dompet',
      logout: 'Keluar',
      product_group: 'Grup Produk',
      product_management: 'Manajemen Produk',
      manage_sku: 'Kelola SKU',
      product_fee: 'Biaya Produk',
      voucherpin: 'Voucher PIN',
      voucher_pin_import: 'Impor Voucher PIN',
      orders: 'Pesanan',
      manage_orders: 'Kelola Pesanan',
    },
    pages: {
      wallet: 'Kelola Saldo Dompet',
      report: 'Pusat Laporan',
      product_group: 'Grup Produk',
      product_management: 'Manajemen Produk',
      manage_sku: 'Kelola SKU',
      voucher_pin: 'PIN Voucher',
      orders: 'Kelola Pesanan',
    },
    orders: {
      title: 'Kelola Pesanan',
      searchPlaceholder: 'Nomor invoice, ID pelanggan, atau ID pembayaran',
      empty: 'Tidak ada pesanan',
      columns: {
        identifier: 'Nomor Invoice',
        createdAt: 'Tanggal',
        status: 'Status',
        paymentMethod: 'Metode Pembayaran',
        paymentId: 'ID Pembayaran',
        customer: 'Pelanggan',
        quantity: 'Jml',
        purchase: 'Pembelian',
        totalFee: 'Total Biaya',
        paymentFee: 'Biaya Pembayaran',
        amount: 'Jumlah Dibayar',
        expiresAt: 'Kedaluwarsa',
      },
      filters: {
        identifierPlaceholder: 'Nomor invoice persis',
        customerPlaceholder: 'ID pengguna pelanggan',
        paymentPlaceholder: 'ID pembayaran',
        paymentMethodPlaceholder: 'ID metode pembayaran',
        amountFrom: 'Jumlah minimum',
        amountTo: 'Jumlah maksimum',
      },
      statuses: {
        waiting_for_payment: 'Menunggu pembayaran',
        paid: 'Lunas',
        processing: 'Diproses',
        pending: 'Tertunda',
        complete: 'Selesai',
        cancelled: 'Dibatalkan',
        expired: 'Kedaluwarsa',
      },
      lineStatuses: {
        pending: 'Tertunda',
        fulfilling: 'Sedang dipenuhi',
        fulfilled: 'Selesai dipenuhi',
        failed: 'Gagal',
      },
      paymentCreation: {
        not_started: 'Belum mulai',
        creating: 'Sedang dibuat',
        created: 'Sudah dibuat',
        unknown: 'Tidak diketahui',
      },
      feeTypes: {
        product_fee: 'Biaya produk',
        payment_fee: 'Biaya pembayaran',
      },
      fulfillmentErrors: {
        delivery_failed: 'Pengiriman gagal',
        destination_invalid: 'Tujuan tidak valid',
        reconciliation_required: 'Perlu rekonsiliasi',
      },
      overview: {
        title: 'Detail Pesanan',
        refresh: 'Muat ulang',
        information: 'Informasi',
        customer: 'Detail Pelanggan',
        payment: 'Informasi Pembayaran',
        amounts: 'Jumlah',
        lines: 'Item',
        breakdown: 'Rincian Pesanan',
        fees: 'Biaya',
        timeline: 'Riwayat Status',
        identifier: 'Nomor Invoice',
        copy: 'Salin nomor invoice',
        copied: 'Nomor invoice disalin',
        paymentMethodId: 'Metode Pembayaran',
        paymentId: 'ID Pembayaran',
        paymentCreation: 'Pembuatan Pembayaran',
        expiresAt: 'Kedaluwarsa',
        currency: 'Mata Uang',
        customerId: 'ID Pelanggan',
        noCustomer: 'Tidak ada ID pelanggan',
        purchase: 'Pembelian',
        totalFee: 'Total Biaya',
        paymentFee: 'Biaya Pembayaran',
        amount: 'Jumlah yang Harus Dibayar',
        product: 'Produk',
        destination: 'Tujuan',
        quantity: 'Jml',
        unitPrice: 'Harga Satuan',
        fulfillment: 'Pemenuhan',
        reviewRequired: 'Perlu ditinjau',
        feeType: 'Tipe',
        feeName: 'Nama',
        feeAmount: 'Jumlah',
        refundable: 'Dapat dikembalikan',
        yes: 'Ya',
        no: 'Tidak',
        noLines: 'Tidak ada item',
        noFees: 'Tidak ada biaya',
        noTimeline: 'Tidak ada riwayat status',
        paymentUrl: 'URL Pembayaran',
        instructions: 'Instruksi Pembayaran',
        notes: 'Catatan',
        addNote: 'Tambah catatan',
        attach: 'Lampirkan berkas',
        removeAttachment: 'Hapus lampiran',
        notePlaceholder: 'Catatan internal',
        noteAdded: 'Catatan ditambahkan',
        noNotes: 'Tidak ada catatan',
        loadingNotes: 'Memuat catatan',
        moreNotes: 'Catatan lebih lama',
        attachments: 'Lampiran',
        attachHint: 'Lampirkan berkas dengan menyeret, menempel, atau klik di sini.',
        fulfillmentDestination: 'Tujuan Pemenuhan',
        fulfillmentError: 'Kesalahan Pemenuhan',
      },
      rowActions: {
        expandRow: 'Buka pesanan',
        collapseRow: 'Tutup pesanan',
      },
    },
    voucherPin: {
      title: 'Kelola Kode PIN Voucher',
      searchPlaceholder: 'Cari awalan PIN',
      empty: 'Tidak ada PIN',
      emptyNoFilter: 'Pilih SKU, status, atau cari untuk melihat kode PIN voucher',
      selectSku: 'Pilih SKU',
      selectStatus: 'Status',
      register: 'Daftarkan Voucher Baru',
      upload: 'Unggah Voucher',
      uploadHistory: 'Lihat Riwayat Unggahan',
      filterByProduct: 'Filter PIN Voucher berdasarkan Produk',
      selectProvider: 'Pilih penyedia',
      selectProduct: 'Pilih produk',
      codesTitle: 'Kode PIN Voucher',
      sold: 'Terjual',
      edit: 'Ubah',
      detail: {
        title: 'Detail Produk',
        view: 'Lihat detail produk',
        productInfo: 'Informasi Produk',
        stockInfo: 'Pengaturan Stok',
        skuId: 'ID SKU',
        code: 'Kode',
        name: 'Nama',
        pinFormat: 'Format PIN',
        legacyProducts: 'Produk Lama',
        lowStock: 'Ambang Stok Rendah',
        restockDelay: 'Jeda Restok',
        disabled: 'Dinonaktifkan',
        recallable: 'Dapat Ditarik',
        yes: 'Ya',
        no: 'Tidak',
        copy: 'Salin',
        unavailable: 'Tidak tersedia',
        expandRow: 'Perluas baris',
        collapseRow: 'Ciutkan baris',
      },
      columns: {
        code: 'Kode',
        sku: 'SKU',
        batch: 'Batch',
        status: 'Status',
        cost: 'Biaya',
        costMin: 'Min',
        costMax: 'Max',
        createdBy: 'Dibuat oleh',
        createdAt: 'Dibuat',
        action: 'Aksi',
        copied: 'Disalin',
        revealing: 'Memuat kode...',
      },
      status: {
        available: 'Tersedia',
        reserved: 'Dipesan',
        allocated: 'Dialokasikan',
        voided: 'Dibatalkan',
      },
      form: {
        registerTitle: 'Daftarkan Voucher Baru',
        uploadTitle: 'Unggah Voucher',
        editTitle: 'Ubah Kode PIN Voucher',
        product: 'Produk',
        provider: 'Penyedia',
        pinCode: 'Kode PIN Voucher',
        pinPlaceholder: 'Masukkan kode PIN voucher',
        histories: 'Riwayat',
        noSubmissions: 'Anda belum mengirim kode PIN voucher',
        submittedCount: 'Terkirim {{count}} kode PIN',
        registerNotice:
          'Pastikan kode voucher yang Anda masukkan untuk <b>{{product}}</b> dari <b>{{provider}}</b>',
        uploadNotice:
          'Pastikan berkas yang Anda pilih untuk <b>{{product}}</b> dari <b>{{provider}}</b>',
        price: 'Harga: <b>{{price}}</b>',
        file: 'Berkas',
        costPrice: 'Harga Modal',
        costInvalid: 'Harga modal tidak boleh melebihi harga produk ({{price}})',
        template: 'Templat',
        templateHint: 'Anda dapat mengunduh templat <link>di sini</link>',
        currentPin: 'PIN saat ini',
        newPin: 'Kode PIN Voucher Baru',
        confirmTitle: 'Apakah Anda yakin?',
        confirmIntro: 'Anda akan mengubah PIN',
        from: 'dari:',
        to: 'menjadi:',
        paste: 'Tempel gambar',
      },
    },
    Button: {
      Info: 'Informasi',
      Success: 'Berhasil',
      Error: 'Gagal',
      Warning: 'Peringatan',
      Confirm: 'Konfirmasi',
    },
    fileUpload: {
      uploading: 'Mengunggah',
      attach_files: 'Lampirkan file dengan Seret & Lepas, Tempel, atau Klik Di Sini',
      errors: {
        // Placeholder names ({size}/{max}/{remaining}) must stay in English —
        // FileUpload.tsx/ImageUpload.tsx substitute them via a plain
        // `.replace('{size}', ...)` call, not i18next interpolation, so a
        // translated placeholder name would never get replaced.
        file_too_large: 'Ukuran file terlalu besar. Ukuran file maksimum adalah {size}MB.',
        max_files:
          'Jumlah file maksimum {max} yang diizinkan. Anda memiliki {remaining} slot tersisa.',
        invalid_content:
          'Konten file tidak valid. Harap unggah gambar yang valid (JPEG, PNG, atau SVG)',
        upload_failed: 'Unggahan gagal. Silakan coba lagi.',
      },
      success: 'File berhasil diunggah.',
      errors_upload_failed: 'Unggahan gagal. Silakan coba lagi.',
    },
    imageUpload: {
      uploading: 'Mengunggah',
      attach_files: 'Lampirkan file dengan Seret & Lepas, Tempel, atau Klik Di Sini',
      addPhoto: 'Tambah Foto',
      main: 'Utama',
      setAsMain: 'Jadikan utama',
      success: 'Gambar berhasil diunggah.',
      errors: {
        file_too_large: 'Ukuran file terlalu besar. Ukuran file maksimum adalah {size}MB.',
        max_files:
          'Jumlah file maksimum {max} yang diizinkan. Anda memiliki {remaining} slot tersisa.',
        invalid_content:
          'Konten file tidak valid. Harap unggah gambar yang valid (JPEG, PNG, atau SVG)',
        upload_failed: 'Unggahan gagal. Silakan coba lagi.',
        not_image: 'Silakan pilih file gambar.',
      },
    },
    pagination: {
      prev: 'Sebelumnya',
      next: 'Selanjutnya',
      prevPageAria: 'Halaman sebelumnya',
      nextPageAria: 'Halaman berikutnya',
    },
    table: {
      filterReset: 'Atur ulang',
    },
    ui: {
      cancel: 'Batal',
      imageCrop: {
        title: 'Unggah Gambar',
        save: 'Simpan',
        invalid: 'Unggah gambar JPG atau PNG maksimal {{max}} MB.',
      },
      emptyState: {
        noData: 'Tidak ada data',
      },
      chart: {
        noData: 'Tidak ada data grafik.',
      },
      dateTimeRangeFilter: {
        startDate: 'Tanggal mulai',
        endDate: 'Tanggal akhir',
      },
      numberRangeFilter: {
        reset: 'Reset',
        search: 'Cari',
      },
      statusBadge: {
        available: 'Tersedia',
        unavailable: 'Tidak tersedia',
        hidden: 'Tersembunyi',
        disabled: 'Nonaktif',
        success: 'Berhasil',
        pending: 'Tertunda',
        failed: 'Gagal',
        refunded: 'Dikembalikan',
        uncertain: 'Tidak pasti',
        processing: 'Memproses',
      },
    },
    report: {
      selectSection: 'Pilih jenis laporan dari menu',
      category: 'Kategori Laporan',
      fulfillment: {
        item: 'Fulfillment',
        title: 'Item Fulfillment',
        description: 'Buat laporan pengadaan item untuk periode yang dipilih',
        supplier: 'Supplier',
        supplierPlaceholder: 'Pilih supplier',
        period: 'Periode',
        export: 'Ekspor',
      },
    },
    fulfillment: {
      empty: 'Tidak ada fulfillment yang cocok dengan filter Anda.',
      columns: {
        transactionId: 'ID Transaksi',
        invoiceNumber: 'Nomor Invoice',
        foreignOrderId: 'ID Pesanan Asing',
        status: 'Status',
        supplier: 'Supplier',
        product: 'Produk',
        cost: 'Biaya',
        walletBalance: 'Saldo Wallet',
        createdAt: 'Dibuat Pada',
        fulfilledAt: 'Dipenuhi Pada',
        errorMessage: 'Pesan Error',
      },
      filters: {
        transactionIdPlaceholder: 'ID Transaksi',
        invoiceNumberPlaceholder: 'Nomor Invoice',
        foreignOrderRefsPlaceholder: 'Masukkan ref (Enter untuk menambah)',
      },
      suppliers: {
        alterra: 'Alterra',
        billfazz: 'Billfazz',
      },
      rowActions: {
        expandRow: 'Perluas baris',
        collapseRow: 'Ciutkan baris',
      },
      overview: {
        generalInfo: 'Informasi Umum',
        orderDetail: 'Detail Pesanan',
        notes: 'Catatan',
        destination: 'Tujuan',
        errorMessage: 'Pesan Error',
        noErrorMessage: 'Tidak ada pesan error',
        errorCode: 'Kode Error',
        vendorErrorCode: 'Kode Error Vendor',
        vendorErrorMessage: 'Pesan Error Vendor',
      },
    },
    aggregator: {
      empty: 'Tidak ada produk aggregator yang cocok dengan filter Anda.',
      columns: {
        product: 'Produk',
        sku: 'Kode SKU',
        type: 'Tipe',
        status: 'Status',
        actions: 'Tindakan',
        errorMessage: 'Pesan Error',
        vendorCost: 'Biaya Pembelian',
      },
      type: {
        prepaid: 'Prabayar',
        postpaid: 'Pascabayar',
      },
      filters: {
        productPlaceholder: 'Produk',
        idPlaceholder: 'ID',
        available: 'Tersedia',
        unavailable: 'Tidak tersedia',
      },
      status: {
        available: 'Tersedia',
        unavailable: 'Tidak tersedia',
      },
      rowActions: {
        action: 'Tindakan',
        edit: 'Edit',
        enable: 'Aktifkan',
        disable: 'Nonaktifkan',
        expandRow: 'Perluas baris',
        collapseRow: 'Ciutkan baris',
      },
      statusModal: {
        disableTitle: 'Nonaktifkan Produk?',
        enableTitle: 'Aktifkan Produk?',
        disableConfirm: 'Nonaktifkan',
        enableConfirm: 'Aktifkan',
        cancel: 'Batal',
        warningTitle: 'Peringatan',
        disableImpact:
          'Dengan menonaktifkan produk ini, pelanggan tidak akan dapat membelinya hingga diaktifkan kembali.',
        disableSuccess: 'Produk berhasil dinonaktifkan',
        enableSuccess: 'Produk berhasil diaktifkan',
        disablePrompt: 'Apakah Anda yakin ingin menonaktifkan',
        enablePrompt: 'Apakah Anda yakin ingin mengaktifkan',
        disableNote: 'Produk akan tetap nonaktif hingga diaktifkan kembali secara manual.',
        enableNote: 'Aksi ini akan membuat produk tersedia untuk fulfillment.',
      },
      overview: {
        generalInfo: 'Informasi Umum',
        aggregatorInfo: 'Informasi Aggregator',
        name: 'Nama',
        vendor: 'Vendor',
        vendorSku: 'SKU',
        priority: 'Prioritas',
        procurementCost: 'Biaya Pembelian',
      },
      editModal: {
        title: 'Edit Produk',
        saveChanges: 'Simpan Perubahan',
        productInfo: 'Informasi Produk',
        productName: 'Nama Produk',
        aggregatorMappings: 'Pemetaan Aggregator',
        aggregatorColumn: 'Aggregator',
        updateSuccess: 'Produk berhasil diperbarui',
      },

    },
    productGroup: {
      empty: 'Tidak ada grup produk yang cocok dengan filter Anda.',
      columns: {
        product: 'Produk',
        price: 'Harga',
        actions: 'Aksi',
      },
      actions: {
        import: 'Impor',
        export: 'Ekspor',
        newGroup: 'Grup Baru',
      },
      rowActions: {
        action: 'Aksi',
        edit: 'Edit',
        editProduct: 'Edit Produk',
        addChild: 'Tambah Anak',
        addPlanGroup: 'Tambah Grup Paket',
        attachProduct: 'Lampirkan Produk',
        changeOrder: 'Ubah Urutan',
        detachProduct: 'Lepaskan Produk',
        enable: 'Aktifkan',
        disable: 'Nonaktifkan',
        delete: 'Hapus',
        expandRow: 'Bentangkan baris',
        collapseRow: 'Ciutkan baris',
      },
      modals: {
        createTitle: 'Tambah Grup Baru',
        editGroupTitle: 'Edit Grup',
        changeOrderTitle: 'Ubah Urutan',
        changeOrderEmpty: 'Belum ada produk di grup ini',
        saveChanges: 'Simpan Perubahan',
        reorder: 'Seret untuk mengubah urutan',
        orderSaved: 'Urutan disimpan',
        editProductTitle: 'Edit Produk',
        attachTitle: 'Lampirkan Produk',
        deleteTitle: 'Hapus Grup',
        deleteProductTitle: 'Hapus Produk',
        detachTitle: 'Lepaskan produk',
        deletePrompt: 'Yakin ingin menghapus "<bold>{{name}}</bold>"?',
        deleteProductPrompt: 'Apakah Anda yakin ingin menghapus "<bold>{{name}}</bold>"?',
        deleteConfirm: 'Hapus',
        deleteNote: 'Anda tidak dapat membatalkan tindakan ini.',
        deleteImpact: 'Dengan menghapus grup ini, beberapa tindakan yang terkait mungkin akan kehilangan referensi grup dan tidak akan tersedia lagi.',
        detachPrompt: 'Apakah Anda yakin ingin melepaskan "<bold>{{name}}</bold>"?',
        groupInformation: 'Informasi Grup',
        name: 'Nama',
        namePlaceholder: 'Masukkan nama',
        nameRequired: 'Nama wajib diisi',
        photo: 'Foto',
        groupType: 'Tipe Grup',
        section: 'Bagian',
        sectionPlaceholder: 'Pilih Bagian',
        sectionRequired: 'Bagian wajib diisi',
        parentGroup: 'Grup Induk',
        parentPlaceholder: 'Pilih Grup Induk',
        hidden: 'Tersembunyi',
        upload: 'Unggah',
        changeImage: 'Ganti gambar',
        removeImage: 'Hapus gambar',
        imageHint: '*Hanya format <bold>gambar</bold> (maks <bold>2MB</bold>)',
        imageTransparent:
          'Gambar harus memiliki <bold>latar transparan</bold> agar latar hijau tetap terlihat.',
        imageTypeError: 'Gambar harus JPG, PNG, atau JPEG.',
        imageSizeError: 'Gambar maksimal 2 MB.',
        types: {
          subgroup: 'Subgroup',
          product: 'Produk',
          esimCountry: 'Negara ESIM',
        },
        sections: {
          dataPerDay: 'Data per hari',
          dataInTotal: 'Data total',
        },
        save: 'Simpan Perubahan',
        createGroup: 'Buat Grup',
        cancel: 'Batal',
        yes: 'Ya',
        no: 'Tidak',
        attach: 'Lampirkan Produk',
        product: 'Produk',
        products: 'Produk',
        selectProduct: 'Pilih produk',
        noProducts: 'Tidak ada produk yang cocok.',
        loadingProducts: 'Memuat produk…',
        attachLoadError: 'Gagal memuat produk',
        productName: 'Nama Produk',
        price: 'Harga',
        availability: 'Ketersediaan',
        available: 'Tersedia',
        notAvailable: 'Tidak tersedia',
        productStatus: 'Status Produk',
        enabled: 'Aktif',
        disabled: 'Nonaktif',
        visibility: 'Visibilitas',
        visible: 'Terlihat',
        refundable: 'Dapat dikembalikan',
        productDisabled: 'Produk dinonaktifkan',
        availableHint: 'Item dapat dibeli',
        notAvailableHint: 'Item tidak dapat dibeli',
        visibleHint: 'Tampil di daftar',
        hiddenHint: 'Disembunyikan dari daftar',
        enabledHint: 'Item aktif dan berfungsi',
        disabledHint: 'Item tidak aktif',
        refund: 'Refund',
        nonRefundable: 'Tidak dapat direfund',
        refundableHint: 'Item memenuhi syarat untuk refund',
        nonRefundableHint: 'Item tidak memenuhi syarat untuk refund',
        locale: 'Locale',
        description: 'Deskripsi',
        descriptionPlaceholder: 'Masukkan deskripsi',
        rootParent: 'Tidak ada (akar)',
        created: 'Grup dibuat',
        updated: 'Grup diperbarui',
        productUpdated: 'Produk diperbarui',
        deleted: '"{{name}}" dihapus',
        productDeleted: '"{{name}}" dihapus',
        detached: '"{{name}}" dilepas',
        attached: 'Produk dilampirkan',
      },
      statusModal: {
        disableTitle: 'Nonaktifkan Produk?',
        enableTitle: 'Aktifkan Produk?',
        disableConfirm: 'Nonaktifkan',
        enableConfirm: 'Aktifkan',
        cancel: 'Batal',
        warningTitle: 'Peringatan',
        disableImpact:
          'Dengan menonaktifkan produk ini, pelanggan tidak akan dapat membelinya hingga diaktifkan kembali.',
        disableSuccess: 'Produk berhasil dinonaktifkan',
        enableSuccess: 'Produk berhasil diaktifkan',
        disablePrompt: 'Apakah Anda yakin ingin menonaktifkan',
        enablePrompt: 'Apakah Anda yakin ingin mengaktifkan',
        disableNote: 'Produk akan tetap nonaktif hingga diaktifkan kembali secara manual.',
        enableNote: 'Aksi ini akan membuat produk tersedia untuk dibeli lagi.',
      },
    },
    productManagement: {
      empty: 'Tidak ada produk yang cocok dengan filter Anda.',
      columns: {
        product: 'Produk',
        priceScheme: 'Skema Harga',
        schemes: {
          fixed: 'Tetap',
          per_account: 'Per Akun',
          user_defined: 'Ditentukan Pengguna',
        },
        price: 'Harga',
        type: 'Tipe',
        types: {
          unit: 'Unit',
          bundle: 'Paket',
        },
        description: 'Deskripsi',
        status: 'Status',
        actions: 'Aksi',
      },
      status: {
        available: 'Tersedia',
        unavailable: 'Tidak tersedia',
        hidden: 'Tersembunyi',
        disabled: 'Nonaktif',
      },
      actions: {
        import: 'Impor',
        export: 'Ekspor',
        changeOrder: 'Ubah Urutan',
      },
      export: {
        title: 'Ekspor',
        provider: 'Penyedia',
        allProviders: 'Semua Penyedia',
        medium: 'Media',
        allMediums: 'Semua Media',
        electronic: 'Elektronik',
        voucherPin: 'Voucher PIN',
        supplier: 'Pemasok',
        allSuppliers: 'Semua Pemasok',
        cancel: 'Batal',
        export: 'Ekspor',
        exported: 'Produk diekspor',
        failed: 'Ekspor gagal',
        stillProcessing: 'Ekspor masih diproses',
        unitHint: 'File hanya berisi produk unit.',
      },
      changeOrder: {
        title: 'Ubah Urutan',
        provider: 'Penyedia',
        selectProvider: 'Pilih Penyedia',
        cancel: 'Batal',
        saveChanges: 'Simpan Perubahan',
        saved: 'Urutan produk {{provider}} disimpan',
      },
      import: {
        title: 'Impor File',
        uploadData: 'Unggah Data',
        downloadTemplate: 'Unduh <template>template</template> untuk melihat contoh format yang diperlukan.',
        dropHint: 'Klik atau seret file ke area ini untuk mengunggah',
        singleFile: 'Anda dapat mengunggah satu file.',
        formats: 'Format file yang didukung: XLSX, XLS, dan CSV.',
        cancel: 'Batal',
        upload: 'Unggah',
        data: 'Data',
        status: 'Status',
        errorDetails: 'Detail Error',
        valid: 'Valid',
        invalid: 'Tidak valid',
        missingColumn: 'Kolom tidak ada',
        successNote: 'Hanya baris yang berhasil yang akan diunggah',
        invalidType: 'Harap unggah file XLSX.',
        imported: 'Produk diimpor',
        started: 'Impor dimulai',
        failed: 'Impor gagal',
        skipped: '{{count}} baris dilewati',
        stillProcessing: 'Impor masih diproses',
        row: 'Baris',
        field: 'Kolom',
        message: 'Pesan',
        summary: 'Menulis {{written}} produk. Melewati {{skipped}}.',
        logNote: 'Periksa baris yang tidak ditulis.',
        noneValid: 'Tidak ada kolom valid untuk diimpor',
        columns: {
          id: 'ID',
          name: 'Nama',
          fapiao_name: 'Nama Fapiao',
          medium: 'Medium',
          price: 'Harga',
          reference_cost_price: 'Harga Modal',
          price_scheme: 'Skema Harga',
          supplier_product_code: 'Kode Produk Supplier',
          denomination_currency: 'Mata Uang Denominasi',
          denomination: 'Denominasi',
          type: 'Tipe',
        },
      },
      rowActions: {
        action: 'Aksi',
        setInstruction: 'Atur Instruksi',
        edit: 'Edit',
        enable: 'Aktifkan',
        disable: 'Nonaktifkan',
      },
      instruction: {
        title: 'Atur Instruksi',
        locale: 'Locale',
        instruction: 'Instruksi',
        placeholder: 'Masukkan instruksi',
        add: 'Tambah Instruksi',
        remove: 'Hapus instruksi',
        cancel: 'Batal',
        saveChanges: 'Simpan Perubahan',
        saved: 'Instruksi disimpan',
      },
      edit: {
        title: 'Edit Produk',
        photoLabel: 'Foto',
        cancel: 'Batal',
        back: 'Kembali',
        next: 'Berikutnya',
        saveChanges: 'Simpan Perubahan',
        saved: 'Produk diperbarui',
        photo: 'Foto',
        uploadTitle: 'Unggah Gambar',
        uploadSave: 'Simpan',
        name: 'Nama',
        description: 'Deskripsi',
        descriptionPlaceholder: 'Masukkan deskripsi',
        locale: 'Locale',
        imageHint: '*Hanya format gambar (maks 2MB)',
        imageTransparent: 'Gambar harus berlatar transparan agar latar hijau tetap terlihat.',
        steps: {
          info: 'Info Produk',
          details: 'Detail Produk',
          visibility: 'Visibilitas & Akses',
        },
        pricing: 'Harga',
        priceScheme: 'Skema Harga',
        priceCurrency: 'Mata Uang Harga',
        price: 'Harga',
        priceBundleHint: 'Harga ini mengikuti paket. Ubah di harga paket.',
        referenceCostCurrency: 'Mata Uang Biaya Referensi',
        referenceCostPrice: 'Harga Biaya Referensi',
        denominationCurrency: 'Mata Uang Denominasi',
        denomination: 'Denominasi',
        productDetails: 'Detail Produk',
        medium: 'Medium',
        type: 'Tipe',
        supplierProductCode: 'Kode Produk Pemasok',
        productBundle: 'Paket Produk',
        bundleSearch: 'Mis. IF atau IF 50 NT',
        bundleCount: '{{count}} item',
        total: 'Total',
        availability: 'Ketersediaan',
        available: 'Tersedia',
        availableHint: 'Item dapat dibeli',
        notAvailable: 'Tidak Tersedia',
        notAvailableHint: 'Item tidak dapat dibeli',
        productStatus: 'Status Produk',
        enabled: 'Aktif',
        enabledHint: 'Item aktif dan berfungsi',
        disabled: 'Nonaktif',
        disabledHint: 'Item tidak aktif',
        visibility: 'Visibilitas',
        visible: 'Terlihat',
        visibleHint: 'Muncul di daftar',
        hidden: 'Tersembunyi',
        hiddenHint: 'Disembunyikan dari daftar',
        access: 'Akses',
        publicAccess: 'Akses Publik',
        publicAccessHint: 'Terlihat oleh semua pengguna',
        restrictedAccess: 'Akses Terbatas',
        restrictedAccessHint: 'Terlihat oleh pengguna terbatas',
        refundable: 'Dapat dikembalikan',
        schemes: { fixed: 'Tetap', per_account: 'Per Akun', user_defined: 'Ditentukan Pengguna' },
        mediums: { voucher_pin: 'PIN Voucher', electronic: 'Elektronik' },
        types: { unit: 'Unit', bundle: 'Paket' },
        bundleColumns: {
          product: 'Produk',
          qty: 'Qty',
          price: 'Harga',
          subtotal: 'Subtotal',
          action: 'Aksi',
        },
      },
    },
    productFee: {
      description: 'Aturan mencocokkan medium produk, supplier, atau keduanya. Biaya persentase bisa ikut dihitung ke biaya pembayaran.',
      summary: '{{count}} aturan',
      empty: 'Belum ada aturan biaya produk',
      anyMedium: 'Semua medium',
      anySupplier: 'Semua supplier',
      yes: 'Ya',
      no: 'Tidak',
      actions: {
        create: 'Buat aturan biaya',
        edit: 'Ubah',
        save: 'Simpan',
        delete: 'Hapus',
      },
      columns: {
        name: 'Nama',
        currency: 'Mata uang',
        products: 'Produk',
        fee: 'Biaya',
        paymentBasis: 'Dasar biaya pembayaran',
        refundable: 'Dapat dikembalikan',
        status: 'Status',
        action: 'Aksi',
      },
      status: {
        enabled: 'Aktif',
        disabled: 'Nonaktif',
      },
      medium: {
        voucher_pin: 'Voucher PIN',
        electronic: 'Elektronik',
        esim: 'eSIM',
        simcard: 'SIM fisik',
      },
      scheme: {
        fixed: 'Tetap',
        percentage: 'Persentase',
      },
      form: {
        createTitle: 'Buat aturan biaya produk',
        editTitle: 'Ubah {{name}}',
        name: 'Nama',
        fapiao: 'Nama fapiao',
        scheme: 'Skema biaya',
        currency: 'Mata uang',
        products: 'ID produk',
        fee: 'Biaya',
        percentageMax: 'Biaya persentase tidak boleh lebih dari 100.',
        paymentBasis: 'Masukkan ke dasar biaya pembayaran',
        paymentBasisHint: 'Aktif: Biaya ini masuk ke persentase pembayaran.\nNonaktif: Dihitung dari harga produk saja.\nBiaya tetap tidak bisa dimasukkan.',
        refundable: 'Dapat dikembalikan',
        refundableHint: 'Biaya ini bisa dikembalikan.',
        enabled: 'Aktif',
        enabledHint: 'Aturan ini sedang aktif.',
        localizedNames: 'Nama terjemahan',
        localizedPlaceholder: 'Nama dalam bahasa ini',
        matchRequired: 'Pilih medium atau supplier. Aturan membutuhkan salah satunya.',
        savedCreate: 'Aturan biaya produk dibuat',
        savedUpdate: 'Aturan biaya produk diperbarui',
        deleteTitle: 'Hapus aturan biaya ini?',
        deleteBody: 'Hapus {{name}}? Produk tidak akan memakai biaya ini lagi.',
        deleted: 'Aturan biaya produk dihapus',
      },
    },
    manageSku: {
      searchPlaceholder: 'Cari kode atau nama SKU',
      empty: 'Tidak ada SKU',
      yes: 'Ya',
      no: 'Tidak',
      actions: { create: 'Buat SKU' },
      filters: {
        status: 'Status',
        enabled: 'Aktif',
        disabledOnly: 'Nonaktif',
        recallable: 'Dapat ditarik',
        recallableYes: 'Dapat ditarik',
        recallableNo: 'Tidak dapat ditarik',
        legacyProductId: 'ID produk lama',
      },
      columns: {
        code: 'Kode SKU',
        name: 'Nama',
        identifier: 'Identifier',
        pinFormat: 'Format PIN',
        lowStock: 'Stok rendah',
        recallable: 'Dapat ditarik',
        status: 'Status',
        legacyProducts: 'Produk lama',
        action: 'Aksi',
      },
      status: { enabled: 'Aktif', disabled: 'Nonaktif' },
      overview: {
        generalInfo: 'Informasi Umum',
        createdAt: 'Dibuat pada',
        updatedAt: 'Diperbarui pada',
      },
      rowActions: { action: 'Aksi', edit: 'Ubah', expandRow: 'Perluas baris', collapseRow: 'Ciutkan baris' },
      form: {
        createTitle: 'Buat SKU',
        editTitle: 'Ubah SKU',
        code: 'Kode SKU',
        name: 'Nama',
        pinFormat: 'Format PIN',
        pinFormatHint: 'Pola RE2 tanpa membedakan huruf. Kosongkan jika tidak ada pemeriksaan format.',
        lowStock: 'Ambang stok rendah',
        restockDelay: 'Jeda restock (Hari)',
        legacyProducts: 'ID produk lama',
        legacyProductsHint: 'ID produk Laravel. Menyimpan mengganti seluruh daftar.',
        disabled: 'Nonaktif',
        recallable: 'Dapat ditarik',
        codeRequired: 'Kode SKU wajib diisi',
        nameRequired: 'Nama wajib diisi',
        invalidLegacyId: 'Masukkan ID produk angka positif',
        create: 'Buat',
        save: 'Simpan',
        created: 'SKU dibuat',
        updated: 'SKU diperbarui',
        notFound: 'SKU tidak ditemukan',
        saveFailed: 'SKU tidak dapat disimpan',
      },
    },
    wallet: {
      average_spending_per_day: 'Rata-rata Pengeluaran per Hari',
      history: 'Riwayat Wallet',
      chart_balance: 'Saldo',
      chart_change: 'Perubahan',
      columns: {
        provider: 'Penyedia',
      },
    },
    voucherPinImport: {
      title: 'Impor Voucher PIN',
      search: 'Cari kode atau nama SKU',
      skuId: 'ID SKU',
      status: 'Status',
      template: 'Unduh template',
      uploadButton: 'Unggah file',
      empty: 'Tidak ada batch impor',
      ownBatches: 'Hanya batch yang Anda buat yang ditampilkan.',
      columns: {
        batch: 'Batch',
        sku: 'SKU',
        file: 'File',
        source: 'Sumber',
        status: 'Status',
        cost: 'Biaya',
        rows: 'Diproses',
        errors: 'Error',
        accepted: 'Diterima',
        createdAt: 'Dibuat',
        action: 'Aksi',
      },
      statuses: {
        uploaded: 'Diunggah',
        ready: 'Siap',
        preflight_failed: 'Preflight gagal',
        committed: 'Tercatat',
        failed: 'Gagal',
        cancelled: 'Dibatalkan',
        expired: 'Kedaluwarsa',
      },
      actions: { view: 'Lihat', commit: 'Commit', cancel: 'Batalkan' },
      rowActions: { expandRow: 'Perluas baris', collapseRow: 'Ciutkan baris' },
      overview: { generalInfo: 'Informasi Umum' },
      confirm: {
        commitTitle: 'Commit batch ini?',
        commitBody: 'Kode PIN yang siap akan masuk ke stok.',
        cancelTitle: 'Batalkan batch ini?',
        cancelBody: 'Batch ini tidak akan diimpor.',
        yes: 'Ya',
        no: 'Tidak',
      },
      upload: {
        title: 'Unggah file PIN',
        hint: 'File harus .xlsx atau .csv dengan header pin_code. Unduh template jika belum punya.',
        skuId: 'ID SKU',
        drop: 'Letakkan file .xlsx atau .csv di sini',
        costPrice: 'Harga modal',
        currency: 'Mata uang',
        autoCommit: 'Commit otomatis jika preflight lolos',
        cancel: 'Batal',
        submit: 'Unggah',
        skuRequired: 'Isi ID SKU yang ada.',
        fileRequired: 'Pilih file .xlsx atau .csv.',
        costInvalid: 'Biaya harus desimal maksimal 4 angka di belakang koma, misalnya 142.5000.',
        currencyInvalid: 'Mata uang harus 3 huruf, misalnya TWD.',
        failed: 'File tidak diterima.',
      },
      detail: {
        title: 'Batch impor',
        close: 'Tutup',
        loading: 'Memuat batch...',
        missing: 'Batch ini tidak bisa dimuat.',
        row: 'Baris',
        stage: 'Tahap',
        message: 'Pesan',
        noLogs: 'Belum ada log.',
        logs: 'Log',
      },
    },
  },
};
